export const sortByDistance = (location1, location2) =>
  parseFloat(location1.distance_to_address) >
  parseFloat(location2.distance_to_address)
    ? 1
    : -1;
